__webpack_require__.p = "/cosher-gurme-frontend/";